import React from 'react';

//import Route
import Route from './routes/index';
import ScrollToTop from '@components/page/ScrollToTop';

function MainApp() {
  return (
    <React.Fragment>
	  <ScrollToTop />
      <Route />
    </React.Fragment>
  )
}

export default MainApp